import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BranchMaster_create, BranchMaster_delete, BranchMaster_GetDictionary, BranchMaster_readAll, BranchMaster_readById, BranchMaster_ReadByUserId, BranchMaster_readyByTenantId, BranchMaster_update } from "src/app/GlobalVariables";
import { BranchMasterCreateRequestDTO, BranchMasterDeleteRequestDTO, BranchMasterDTO, BranchMasterList, BranchMasterReadByTenantIdRequestDTO, BranchMasterReadByIdRequestDTO, BranchMasterReadByUserIdRequestDTO, BranchMasterUpdateRequestDTO } from "./branchmaster.interface";
import { GetDictionaryList } from "../common.interface";
import { resolveTenantUrl } from "src/app/Common/ApiConfigurationService/resolve-tenant-url.util";
import { SKIP_TENANT_URL_REWRITE } from "src/app/api-url-rewrite.interceptor";

@Injectable({
    providedIn: 'root'
})
export class BranchMasterService {


    constructor() { }

    http = inject(HttpClient);

    BranchMaster_create(data: BranchMasterCreateRequestDTO): Observable<BranchMasterDTO> {
        return this.http.post<BranchMasterDTO>(BranchMaster_create, data);
    }

    BranchMaster_update(data: BranchMasterUpdateRequestDTO): Observable<BranchMasterDTO> {
        return this.http.post<BranchMasterDTO>(BranchMaster_update, data);
    }


    BranchMaster_readAll(): Observable<BranchMasterList> {
        return this.http.get<BranchMasterList>(BranchMaster_readAll);
    }

    BranchMaster_readById(data: BranchMasterReadByIdRequestDTO): Observable<BranchMasterDTO> {
        return this.http.post<BranchMasterDTO>(BranchMaster_readById, data);
    }

    BranchMaster_delete(data: BranchMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(BranchMaster_delete, data);
    }

    BranchMaster_readByUserId(data: BranchMasterReadByUserIdRequestDTO): Observable<BranchMasterList> {
        return this.http.post<BranchMasterList>(BranchMaster_ReadByUserId, data);
    }
    
    // baseUrlOverride (optional, read methods only): the viewed tenant's own
    // AM gateway origin, e.g. CompanyDetailComponent.apiConfigOverride.AM.
    // Omitted for every other caller - behaves exactly as before.
    BranchMaster_GetDictionary(data: BranchMasterReadByUserIdRequestDTO, baseUrlOverride?: string): Observable<GetDictionaryList> {
        return this.http.post<GetDictionaryList>(resolveTenantUrl(BranchMaster_GetDictionary, baseUrlOverride), data, this.overrideOptions(baseUrlOverride));
    }

     BranchMaster_readByTenantId(data : BranchMasterReadByTenantIdRequestDTO, baseUrlOverride?: string): Observable<BranchMasterList>{
        return this.http.post<BranchMasterList>(resolveTenantUrl(BranchMaster_readyByTenantId, baseUrlOverride), data, this.overrideOptions(baseUrlOverride));
    }

    // Explicitly opts a tenant-overridden request out of ApiUrlRewriteInterceptor's
    // app-wide rewriting (keyed to the LOGGED-IN user's own tenant) - resolveTenantUrl()
    // has already pointed this request at the correct viewed-tenant origin.
    private overrideOptions(baseUrlOverride?: string) {
        return baseUrlOverride ? { context: new HttpContext().set(SKIP_TENANT_URL_REWRITE, true) } : {};
    }
}